(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("countdown", [], factory);
	else if(typeof exports === 'object')
		exports["countdown"] = factory();
	else
		root["countdown"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 